import React from "react";

export default function TiptapHtmlToggle({ htmlMode, onToggle, onFormatHtml }) {
  return (
    <div className="lh6-footerLeft">
      <span className="lh6-modeLabel">HTML</span>
      <button
        type="button"
        className={`lh6-modeSwitch ${htmlMode ? "is-active" : ""}`}
        onClick={onToggle}
        aria-label="HTML-Modus"
        aria-pressed={htmlMode}
      >
        <span className="lh6-modeSwitchKnob" />
      </button>
      {htmlMode ? (
        <button type="button" className="lh6-htmlFmtBtn" onClick={onFormatHtml}>
          Format
        </button>
      ) : null}
    </div>
  );
}
